import { lazyWithPreload } from '../../navigation';

export const ChangeRequestsScreen = lazyWithPreload(() => import('./ChangeRequestsScreen.lazy'));
